import ManualBillingDocumentAmountTtc from '@/generated/controls/manualBillingDocument/ManualBillingDocumentAmountTtc.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: ManualBillingDocumentAmountTtc
})
